import { z } from "zod";

export const DTODocumentationSettings = z.object({
  isDraftFeatureAdopted: z.boolean(),
  isApprovalsFeatureEnabled: z.boolean(),
  isApprovalRequiredForPublishing: z.boolean(),
});

export type DTODocumentationSettings = z.infer<typeof DTODocumentationSettings>;
